const DNA2Colums=[
    {
        key:"1",
        title:"Compare varietys",
        dataIndex:"Compare_Varietys",
        align:"center",
    },
    {
        key:"2",
        title:"Chr",
        dataIndex:"Chr",
        align:"center"
    },
    {
        key:"3",
        title:"Start",
        dataIndex:"Start",
        align:"center"
    },
    {
        key:"4",
        title:"End",
        dataIndex:"End",
        align:"center"
    },
    {
        key:"5",
        title:"DMR_Length",
        dataIndex:"DMR_Length",
        align:"center"
    },
    {
        key:"6",
        title:"nCG",
        dataIndex:"nCG",
        align:"center"
    },
    {
        key:"7",
        title:"Group1_meanMethy",
        dataIndex:"Group1_meanMethy",
        align:"center"
    },
    {
        key:"8",
        title:"Group2_meanMethy",
        dataIndex:"Group2_meanMethy",
        align:"center"
    },
    {
        key:"9",
        title:"diff_Methy",
        dataIndex:"diff_Methy",
        align:"center"
    },
    {
        key:"10",
        title:"areaStat",
        dataIndex:"areaStat",
        align:"center"
    },
    {
        key:"10",
        title:"C_context",
        dataIndex:"C_context",
        align:"center"
    }
]
export default DNA2Colums